<template>
    <div class="box">
        <Swiper class="main_swiper" :options="mainOption" v-if="swipers && swipers.length">
            <SwiperSlide class="slide" v-for="img in swipers" :key="img">
                <img class="slide_img" :src="img"  @click="preview"/>
            </SwiperSlide>
            <div class="swiper_btn swiper-button-next" slot="button-next"></div>
            <div class="swiper_btn swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-pagination" slot="pagination"></div>
        </Swiper>
        <div class="content" v-html="content" v-if="content"></div>
        <el-dialog :title="portsName" :visible.sync="dialogVisible" :width="swipers.length >=4?'880px':'640px'" append-to-body>
            <div class="flex ">
                <Swiper class="w-160 h-120" :key="mainSwiperId"  :options="dialogSwiperOption">
                    <SwiperSlide class="rounded" v-for="img in swipers" :key="img">
                        <img class="rounded w-full h-full object-cover" :src="img"/>
                    </SwiperSlide>
                    <div class="swiper_btn swiper-button-next" slot="button-next"></div>
                    <div class="swiper_btn swiper-button-prev" slot="button-prev"></div>
                </Swiper>
                <Swiper ref="smallSwiperRef" class="thumbnail_swiper" :options="thumbsOption" v-if="swipers && swipers.length>=2">
                    <SwiperSlide class="slide" v-for="(img, i) in swipers" :key="i">
                        <img class="slide_img" :src="img" />
                    </SwiperSlide>
                </Swiper>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import { defineComponent,computed, nextTick, watch, ref } from "@nuxtjs/composition-api";
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

    export default defineComponent({
        name:"routePortsDetail",
        props:{
            swipers:[],
            content:'',
            portsName:''
        },
        data() {
            return {
                dialogVisible:false,
                mainOption: {
                    spaceBetween: 10,
                    pagination:{ 
                        el:'.swiper-pagination',
                        type: 'fraction',
                        clickable: true
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                }
            }
        },
        components: {
            Swiper,
            SwiperSlide
        },
        setup(){
            const thumbsOption = computed(() => ({
                direction: 'vertical',
                spaceBetween: 12,
                slidesPerView: 4,
                touchRatio: 0.2,
                slideToClickedSlide: true
            }));

            const smallSwiperRef = ref();

            const thumbsSwiper = computed(() => {
                return smallSwiperRef.value ? smallSwiperRef.value.$swiper : null;
            })

            const dialogSwiperOption = computed(() => ({
                spaceBetween: 10,
                thumbs: { swiper: thumbsSwiper.value, autoScrollOffset:1 },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            }));
            const mainSwiperId = ref(0);

            watch(thumbsSwiper, () => {
                if (thumbsSwiper.value) {
                    // nextTick(() => {
                        mainSwiperId.value++
                    // })
                }
            })

            return {
                thumbsOption,
                dialogSwiperOption,
                mainSwiperId,

                smallSwiperRef,
                thumbsSwiper
            }
        },
        methods:{
            preview(){
                this.dialogVisible = true
            }
        }
    })
</script>

<style lang="scss" scoped>
.box {
  display: flex;
}
.box .main_swiper {
  height: 11.25rem;
  width: 15rem;
}
.box .main_swiper .swiper_btn {
  --swiper-navigation-size: 24px;
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
  border-radius: 9999px;
  border-width: 1px;
  height: 2.25rem;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  width: 2.25rem;
}
.box .main_swiper .slide {
  border-radius: 0.25rem;
}
.box .main_swiper .slide_img {
  border-radius: 0.25rem;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  width: 100%;
}
.box .main_swiper .swiper-pagination {
  color: #fff;
  width: auto;
  right: 8px;
  left: auto;
  background-color: rgba(0,0,0,0.8);
  border-radius: 40px;
  padding: 0 10px;
}
.box .content {
  flex: 1;
  white-space: pre-wrap;
  padding-left: 20px;
  font-size: 14px;
  color: #3d3d3d;
}
.thumbnail_swiper {
  width: 160px;
  height: 480px;
  margin-left: 20px;
}
.thumbnail_swiper ::v-deep .swiper-slide-thumb-active {
  border: 2px solid #000000;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.2);
}
.thumbnail_swiper .slide {
  border-radius: 0.25rem;
  -o-object-fit: cover;
  object-fit: cover;
}
.thumbnail_swiper .slide_img {
  border-radius: 0.25rem;
  height: 100%;
  width: 100%;
}
</style>